module.exports = __webpack_public_path__ + "static/img/pingtaijieshao.0812bf01.png";